/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getProposalDoc } from "../ducks/actions";
import { Card, Col, Row } from "antd";
import FullPageLayout from "../../../templates/FullPageLayout";
import DocumentHeader from "./DocumentHeader";
import { PopUp } from "../../../atoms/PopUp";
import SignModal from "./SignModal";
import RevisionModal from "./RevisionModal";

export default function ProposalBuilder() {
  const dispatch = useAppDispatch();
  const [showSignModal, setShowSignModal] = useState(false);
  const [showRevisionModal, setShowRevisionModal] = useState(false);
  const locationUrl = window.location.pathname;
  const pathSegments = locationUrl.split("/");
  // const companyId = pathSegments[pathSegments.length - 1];
  // const estimateId = pathSegments[pathSegments.length - 2];
  const proposalId = pathSegments[pathSegments.length - 1];

  const proposalDocument = useAppSelector(
    (state) => state?.potentialDeal?.proposalDocument
  );

  useEffect(() => {
    if (proposalId) {
      dispatch(getProposalDoc(proposalId));
    }
  }, [dispatch, proposalId]);

  const showSignModalPop = {
    visibility: showSignModal,
    class: "upload_photo_modal",
    content: (
      <SignModal
        onClose={() => setShowSignModal(false)}
        proposalDocumentData={
          proposalDocument?.data?.client_contact ?? undefined
        }
      />
    ),
    width: 480,
    onCancel: () => setShowSignModal(false),
  };

  const revisionModal = {
    visibility: showRevisionModal,
    class: "upload_photo_modal",
    content: (
      <RevisionModal
        onClose={() => setShowRevisionModal(false)}
        proposalDocId={proposalDocument?.data?.id ?? ""}
      />
    ),
    width: 480,
    onCancel: () => setShowRevisionModal(false),
  };

  function insertSignatureUrl(html: string, signatureUrl: string): string {
    return html.replace(/'<%= signed_url %>'/g, signatureUrl);
  }

  return (
    <FullPageLayout loading={proposalDocument?.loader}>
      <div className="estimateWrapper">
        <DocumentHeader
          // companyId={companyId}
          // estimateId={estimateId}
          showSignModal={() => setShowSignModal(true)}
          setShowRevisionModal={() => setShowRevisionModal(true)}
          proposalDocumentData={proposalDocument?.data}
        />

        <Card
          className="editorContent editorContentTemplate"
          style={{ margin: 0 }}
        >
          <Row gutter={12} wrap={false}>
            <Col flex="234px">
              <Card style={{ backgroundColor: "#F6F9F9", border: "unset" }}>
                <div className="editorHeader">
                  <h3> Sections </h3>
                </div>
                <div className="editorBody">
                  <ul>
                    {proposalDocument?.data?.table_columns?.map(
                      (item, index) => (
                        <li key={index}>
                          {index + 1}. {item}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </Card>
            </Col>
            <Col flex="auto">
              <Card
                className="documentEditor additional_card_ui"
                style={{
                  margin: 0,
                  backgroundColor: "#DBF1EA",
                  border: "unset",
                }}
              >
                <div
                  className="documentEditorMain"
                  dangerouslySetInnerHTML={{
                    __html:
                      insertSignatureUrl(
                        proposalDocument?.data?.html ?? "",
                        proposalDocument?.data?.signature_url ?? ""
                      ) || "",
                  }}
                />
              </Card>
            </Col>
          </Row>
        </Card>
      </div>
      <PopUp {...showSignModalPop} />
      <PopUp {...revisionModal} />
    </FullPageLayout>
  );
}
